import Project from "./project";

class ProjectList {
  #projectList = [];

  constructor() {
    if (!new.target) {
      throw Error("Use the new operator to create a new object.");
    }
    this.#projectList = [];
  }

  addProject(title) {
    this.#projectList.push(new Project(title));
  }

  removeProject(project) {
    this.#projectList = this.#projectList.filter((item) => item !== project);
  }

  getProjectList() {
    return [...this.#projectList];
  }

  getProject(title) {
    return this.#projectList.find(
      (project) => project.getProjectTitle() === title
    );
  }

  taskExists(title, description, dueDate, priority) {
    const projects = this.#projectList;
    return projects.some((project) =>
      project
        .getTasks()
        .some(
          (task) =>
            task.getTitle() === title &&
            task.getDescription() === description &&
            task.getDueDate().getTime() === dueDate &&
            task.getPriority() === priority
        )
    );
  }

  findTaskInProjects(id) {
    const projects = this.#projectList;
    for (const project of projects) {
      const task = project.getTask(id);
      if (task) {
        return { task, project };
      }
    }
    return undefined;
  }
}

const projectList = new ProjectList();
export default projectList;
